import * as React from "react";
import { FC, useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { AskModal } from "../AskModal";
interface Props {
  passPortal: (ap, campaign, deviceId) => any;
}

export const NewDescription: FC<Props> = ({ passPortal }) => {
  let { location, push, replace, goBack } = useHistory();
  const {
    DeviceID,
    ap,
    band,
    campaign,
    search,
    survey_ids,
    token,
    threshold,
    userData,
    skip_seconds,
    each_seconds,
    bc_seconds,
    postBalance
  }: any = location.DeviceID ? location : location.state;
  let timeout = null;
  let interval = null;
  const [count, setCount] = useState(bc_seconds ? bc_seconds : 15);
  const [showModal, setShowModal] = useState(false);
  let countLocal = bc_seconds;
  useEffect(() => {
    getSedTag();
    postImpression("content");

    return () => {
      clearInterval(interval);
    };
  }, []);

  const postImpression = async (MediaType: string) => {
    const fields = {
      AccessPointID: ap.ap_mac,
      LocationID: Number(ap.ap_locationid),
      DeviceID,
      CampaignID: campaign.CampaignID,
      MediaType,
    };
    try {
      await axios.post("/impressions", { fields });
      if (MediaType === "post") {
        passPortal(ap, campaign, DeviceID);
      } else {
        initialTimeOut();
      }
      await postBalance(campaign, "click");
    } catch (err) {
      console.log("error posting /campaigns on deal item click");
      if (MediaType !== "post") {
        initialTimeOut();
      }
    }
  };

  const initialTimeOut = () => {
    interval = setInterval(() => {
      countLocal = countLocal - 1;
      setCount(countLocal);
      if (countLocal === 0) {
        setShowModal(true);
        clearInterval(interval);
      }
    }, 1000);
  };

  const _goBack = () => {
    if (search) {
      replace(`/${search}`);
    } else {
      goBack();
    }
  };


  const getSedTag = () => {
/* window._seedtagq = window._seedtagq || [];
window._seedtagq.push(['_setId', '2995-5604-01']);
(function () {
  var st = document.createElement('script');
  st.type = 'text/javascript';
  st.async = true;
  st.src = ('https:' == document.location.protocol
    ? 'https'
    : 'http') + '://config.seedtag.com/loader.js?v=' + Math.random();
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(st, s);
})(); */
(window as any)._seedtagq =  (window as any)._seedtagq || [];
(window as any)._seedtagq.push(['_setId', '2995-5604-01']);
    //window._seedtagq.push(['iframe_mode']);
    
    (function () {
      let st = document.createElement('script');
      st.type = 'text/javascript';
      st.async = true;
      st.src = ('https:' == document.location.protocol
        ? 'https'
        : 'http') + '://config.seedtag.com/loader.js?v=' + Math.random();
      let s = document.getElementsByTagName('script')[0];
      //console.log(document.getElementsByTagName("script"));
      s.parentNode.insertBefore(st, s);
    })();

  }; 

  return (
    <div className="row w-100 m-0">
      {showModal && (
        <AskModal ok={() => postImpression("post")} cancel={_goBack} />
      )}
      <div
        className="row m-0 p-0 w-100"
        style={{
          backgroundColor: "#dc3545",
          color: "#fff",
        }}
      >
        <div className="col-8">
          <h4 className="m-1">{campaign.CampaignName}</h4>
        </div>
        <div className="col-4 text-center">
          <h5 style={{ fontSize: "16px" }}>Wifi Gratis: </h5>
          <span>{count}</span>
        </div>
      </div>
      <img
        className="img-fluid w-100"
        src={`/google-storage/${encodeURIComponent(
          campaign.newsID.urlToImageGC
        )}`}
        alt="img"
      />
      <div
        className="row w-100 pt-2 m-0"
        style={{
          fontSize: "10px",
        }}
      >
        <div className="col-auto">
          <strong>Por </strong>
          <span className="text-muted">
            {campaign.newsID.author} {" | "}
          </span>
        </div>
        <div className="col-auto">
          <span className="text-muted">
            {" "}
            {campaign.newsID.publicationDate.split("T")[0]} {" | "}
          </span>
        </div>
        <div className="col-auto">
          <strong>Fuente: </strong>
          <span className="text-muted"> {campaign.newsID.source} </span>
        </div>
      </div>
      <div className="row w-100 pt-2 m-2">{campaign.newsID.content}</div>
      {/* <div className="row w-100 pt-2 m-0">
          <Link to={{
              pathname: "/content",
              campaign: campaign,
              DeviceID,
              ap,
              band,
              survey_ids,
              search: search,
              token: token,
              threshold,
              userData,
              skip_seconds,
              each_seconds
          }} className="btn btn-primary w-100 m-2" onClick={() => postImpression("content") } >
            Continuar {" >>"}
          </Link>
        </div> */}
    </div>
  );
};
